"use client";

import { usePathname } from "next/navigation";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "@/utils/library/languages";
import { getTranslatedPath } from "@/utils/routes";

export function getLocaleFromPathname(pathname: string | null): string {
  const segment = pathname?.split("/")[1] ?? "";
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(segment)
    ? segment
    : DEFAULT_LANGUAGE;
}

export function useLocalePath() {
  const pathname = usePathname();
  const lang = getLocaleFromPathname(pathname);

  return (path: string) => {
    if (path === "/") {
      return `/${lang}`;
    }
    const normalized = path.startsWith("/") ? path : `/${path}`;
    const translated = getTranslatedPath(normalized, lang);
    return `/${lang}${translated}`;
  };
}
